import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { DialogActions, DialogContent } from '@material-ui/core';
import H5 from '@base/H5/H5';
import P2 from '@base/P2/P2';
import Button from '@base/Button/Button';
import { Fonts, Spacings } from '@styles/index';
import Coin from '@icon/Coin';

const ContentContainer = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const RequiredCredits = styled.div`
  display: grid;
  align-items: center;
  grid-template: 1fr / repeat(2, max-content);
  grid-column-gap: ${Spacings.SPACING_2B};
  margin-top: ${Spacings.SPACING_5B};
`;

const Value = styled(H5)`
  font-size: 40px;
  line-height: ${Fonts.BUTTON_LINE_HEIGHT};
`;

const TotalContainer = styled.div`
  display: grid;
  align-items: center;
  grid-template: 1fr / repeat(3, max-content);
  grid-column-gap: ${Spacings.SPACING_1B};
  margin: ${Spacings.SPACING_6B} 0px;
`;

const Text = styled(P2)`
  line-height: ${Fonts.BUTTON_LINE_HEIGHT};
`;

const StyledBtn = styled(Button)`
  background-image: linear-gradient(
    180deg,
    var(--color-i-blue-4) 0%,
    var(--color-i-blue-3) 100%
  );
`;

const UseCredits = ({
  Modal,
  show,
  onClose,
  requiredCredits,
  credits,
  enroll
}) => {
  return (
    <Modal dialogState={show} onClose={onClose}>
      <ContentContainer>
        <H5>Enroll using credits</H5>
        <RequiredCredits>
          <Coin size="32px" viewBox="0 0 32 32" />
          <Value>{requiredCredits}</Value>
        </RequiredCredits>
        <TotalContainer>
          <Text>You have</Text>
          <Coin size="12px" viewBox="0 0 32 32" />
          <Text>{credits}</Text>
        </TotalContainer>
      </ContentContainer>
      <DialogActions>
        <Button
          label="Cancel"
          variant="hollow"
          color="black"
          onClick={onClose}
        />
        <StyledBtn label="Enroll now" onClick={() => enroll()} />
      </DialogActions>
    </Modal>
  );
};

UseCredits.propTypes = {
  Modal: PropTypes.node.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  requiredCredits: PropTypes.number.isRequired,
  credits: PropTypes.number.isRequired,
  enroll: PropTypes.func.isRequired
};

export default UseCredits;
